import React, { useState } from "react";
import { CustomeStyle } from "../Css/CustomeStyle";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { useDispatch } from "react-redux";
import { viewCartData } from "../redux/slices/ViewCartSlice";

const AllProduct = ({ ...props }) => {
  const dispatch = useDispatch();
  const products = props?.product;
  const [likedProducts, setLikedProducts] = useState(new Set());

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const generateSlug = (text) => {
    if (!text) {
      // console.log("⚠️ Warning: Slug generation failed due to null value!");
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  return (
    <div>
      <div className="flex overflow-x-auto mt-[10px] gap-4 no-scrollbar ">
        {products?.slice(0, 20)?.map((item, index) => {
          return (
            <div
              key={index}
              className="bg-gray-100 rounded-lg py-2 px-1 w-[145px] sm:w-[180px] 
              md:w-[150px] flex-none text-center flex flex-col items-center justify-center 
               cursor-pointer overflow-hidden-hidden "
            >
              <button
                className="like-btn absolute top-2 right-2"
                onClick={() => toggleLike(item._id)}
              >
                {likedProducts.has(item._id) ? (
                  <FaHeart size="24px" color="red" />
                ) : (
                  <FaRegHeart size="24px" color="gray" />
                )}
              </button>
              <img
                loading="lazy"
                src={
                  item?.productimage1
                    ? item?.productimage1
                    : item?.images?.productimage1
                      ? item?.images?.productimage1
                      : item.image
                }
                alt={item.name}
                className="w-30 h-[60px] sm:h-[80px] md:h-[120px] object-cover rounded-lg mb-2"
              />
              <Link
                to={`/shop/${item?.category ? generateSlug(item?.category) : "-"
                  }/${item?.subcategory ? generateSlug(item?.subcategory) : "-"
                  }/${item?.title ? generateSlug(item?.title) : "-"}`}
                state={{ item }}
                className="block w-[100%] hover:scale-105 hover:-translate-y-1"
                onClick={() => {
                  dispatch(viewCartData(item));
                }}
              >
                <p
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "98%",
                  }}
                  className={CustomeStyle.OnetextBlack}
                >
                  {item.title}
                </p>
                {/* <h3 className={CustomeStyle.description}>{item.description}</h3> */}
                <div className="flex items-center justify-center gap-1">
                  <span className="text-black text-lg font-bold">
                    ₹{item?.salePrice}
                  </span>
                  <span className="line-through text-gray-500 text-sm">
                    ₹{item?.regularPrice}
                  </span>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AllProduct;
